import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { homeData } from '@/data/homeContent';
import { useScrollReveal } from '@/hooks/useScrollReveal';

function StatCounter({ value, suffix, label }: { value: string; suffix: string; label: string }) {
  const { ref, visible } = useScrollReveal<HTMLDivElement>();
  const target = parseInt(value, 10) || 0;
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!visible) return;
    let raf = 0;
    const start = performance.now();
    const duration = 1200;
    const tick = (now: number) => {
      const progress = Math.min(1, (now - start) / duration);
      setN(Math.round(progress * target));
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [visible, target]);

  return (
    <div className="mgc-stat" ref={ref}>
      <div className="mgc-stat-value">
        {n}
        {suffix && <span className="mgc-stat-suffix">{suffix}</span>}
      </div>
      <div className="mgc-stat-label">{label}</div>
    </div>
  );
}

export default function AccreditationStats() {
  const { t } = useTranslation();
  const stats = homeData.stats.filter(stat => t(stat.labelKey));
  if (stats.length === 0) return null;
  return (
    <div className="mgc-stats">
      {stats.map((stat, i) => (
        <StatCounter key={i} value={stat.value} suffix={stat.suffix} label={t(stat.labelKey)} />
      ))}
    </div>
  );
}
